export default "__VITE_ASSET__BXp8_npm__"